export default __webpack_public_path__ + "static/media/mySurprise_Logo_Trademark.78c949db.png";